import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col, Form, Select } from 'antd';
import { fetchBloodProcessingSearch } from 'services/blood_inventory/blood_processing';
import './index.css';

const { Option } = Select;

class FormSearch extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			bloodType: '',
			loading: false,
			disable: true,
		};
	}

	onFinish = async payload => {
		const { onFinish, selectedTabkey } = this.props;
		payload.Blood_Components_Code = selectedTabkey;
		const APIresponseBloodProcessing = await fetchBloodProcessingSearch(payload);
		onFinish(APIresponseBloodProcessing, payload);
	};

	onChange = value => {
		this.setState({
			bloodType: value,
			disable: false,
		});
	};

	render() {
		const { disable } = this.state;
		const { bloodTypesList, bloodStorageList } = this.props;

		const bloodTypesOption =
			bloodTypesList === undefined
				? null
				: bloodTypesList.map((item, i) => {
						return (
							<Option key={i} value={item.blood_type}>
								{item.blood_type}
							</Option>
						);
				  });

		const bloodStorageOption =
			bloodStorageList === undefined
				? null
				: bloodStorageList.map((item, i) => {
						return (
							<Option key={i} value={item.storage_name}>
								{item.storage_name}
							</Option>
						);
				  });

		return (
			<Form onFinish={this.onFinish} className="blood-product-search-form">
				<div className="container">
					<Col className="blood-types">
						<Form.Item name="BLOOD_TYPES">
							<Select placeholder="Select Blood Types" allowClear={true} onChange={this.onChange}>
								{bloodTypesOption}
							</Select>
						</Form.Item>
					</Col>
					<Col className="blood-storage">
						<Form.Item name="BLOOD_STORAGE">
							<Select placeholder="Select Storage" allowClear={true} onChange={this.onChange}>
								{bloodStorageOption}
							</Select>
						</Form.Item>
					</Col>
					<div className="buttons">
						<Button shape="round" style={{ width: 120 }}>
							CLEAR
						</Button>

						<Button
							htmlType="submit"
							shape="round"
							type="primary"
							style={{ width: 120 }}
							disabled={disable}
						>
							SEARCH
						</Button>
					</div>
				</div>
			</Form>
		);
	}
}

FormSearch.propTypes = {
	bloodTypesList: PropTypes.array,
	bloodStorageList: PropTypes.array,
	selectedTabkey: PropTypes.string,
};

export default FormSearch;
